export const formExtraHeaderUIType = {
  embeddedScholarshipFormUI: 'EMBEDDED_SCHOLARSHIP_FORM_UI',
  embeddedAslScholarshipFormUI: 'EMBEDDED_ASL_SCHOLARSHIP_FORM_UI',
  webinarRegistrationFormUI: 'WEBINAR_REGISTRATION_FORM_UI'
};

export enum formSubmissionActionType {
  createAsNew = 'CREATE_AS_NEW',
  overrideOldSubmission = 'OVERRIDE_OLD_SUBMISSION'
}
